export interface NavigationUsageTracking {
  anonymousGuid?: string;
  currentUrl?: string;
  previousUrl?: string;
}
